import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Input, Form, Button, FormText, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";

import ResetPasswordModal from "./ResetPasswordModal";
import userActions from "../../actions/userActions";
import alertConstants from "../../constants/alertConstants";
import attorneyActions from "../../actions/attorneyActions";

function Attorneys() {
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alert);
  const [submittedStep, setSubmittedStep] = useState("0");
  const [registerStep, setRegisterStep] = useState("0");
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  const {
    register: registerRegister,
    errors: errorsRegister,
    handleSubmit: handleSubmitRegister,
    reset: resetRegister,
  } = useForm({
    mode: "onChange",
  });

  const onSubmit = (data) => {
    if (data.username && data.password) {
      setSubmittedStep("1");
      dispatch(userActions.login(data.username, data.password));
    }
  };

  const onSubmitRegister = (data) => {
    dispatch(
      attorneyActions.register(
        data.firstName,
        data.lastName,
        data.email,
        data.phoneNumber,
        data.barNumber
      )
    );
    setRegisterStep("1");
    resetRegister({});
    //console.log(test);
  };

  useEffect(() => {
    dispatch(userActions.logout());
  }, [dispatch]);

  useEffect(() => {
    //console.log(alert);
    if (alert.type === alertConstants.ERROR) {
      setSubmittedStep("0");
    }
  }, [alert]);

  return (
    <Row className="psInfo">
      <Col>
        <h2 className="text-center text-uppercase">Attorneys</h2>
        <hr />
        <Row>
          <Col className="d-flex justify-content-center">
            <p>
              Volunteer attorneys should be available to answer questions,
              review filings, and address other matters that pro se litigants
              may encounter. Please fill out the form below in order to be
              considered for volunteer work:
            </p>
          </Col>
        </Row>
        <Row className="psInfo">
          <Col xl={6}>
            <h4>Sign in</h4>
            <p>View and confirm your appointments. Log in here.</p>
          </Col>
          <Col xl={6}>
            <h4>Register</h4>
            <p>Register below and a staff member will get back to you.</p>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            {/* Login */}
            <Form key={1} onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col>
                  <Input
                    type="email"
                    name="username"
                    innerRef={register({
                      required: true,
                      minLength: 3,
                      maxLength: 256,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email address.",
                      },
                    })}
                    placeholder="E-mail"
                    autoComplete="off"
                    className={errors?.username ? "custError" : ""}
                  />
                  <FormText>
                    Enter your email.{" "}
                    <i style={{ color: "red" }}>
                      {errors.username && errors.username.message}
                    </i>
                    {errors?.username?.type === "required" && (
                      <i style={{ color: "red" }}> Email required.</i>
                    )}
                    {errors?.username?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
                <Col>
                  <Input
                    type="password"
                    name="password"
                    innerRef={register({
                      required: true,
                      minLength: 6,
                    })}
                    placeholder="Password"
                    autoComplete="off"
                    className={errors?.password ? "custError" : ""}
                  />
                  <FormText>
                    Enter your password.
                    {errors?.password?.type === "required" && (
                      <i style={{ color: "red" }}> Password required.</i>
                    )}
                    {}
                    {errors?.password?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col>
                  <div className={submittedStep === "1" ? "d-block" : "d-none"}>
                    <Spinner color="dark" />
                  </div>
                  <div className={submittedStep === "2" ? "d-block" : "d-none"}>
                    <p>Thank you, your request has been submitted.</p>
                  </div>
                  <Button
                    type="submit"
                    className={
                      submittedStep === "0" ? "blueButton d-block" : "d-none"
                    }
                    style={{ width: "100%", height: "100%" }}
                  >
                    Login
                  </Button>
                  <ResetPasswordModal buttonLabel="Forgot Password?" />
                </Col>
              </Row>
            </Form>
          </Col>
          <Col xl={6} className={registerStep === "1" ? "d-block" : "d-none"}>
            <h4>
              Thank you for registering. A staff member will contact you soon.
            </h4>
          </Col>
          <Col xl={6} className={registerStep === "0" ? "d-block" : "d-none"}>
            {/* Register */}
            <Form key={2} onSubmit={handleSubmitRegister(onSubmitRegister)}>
              <Row>
                <Col md={6}>
                  <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    innerRef={registerRegister({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="First name"
                    className={errorsRegister?.firstName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your first name.{" "}
                    {errorsRegister?.firstName?.type === "required" && (
                      <i style={{ color: "red" }}> First name is required.</i>
                    )}
                    {errorsRegister?.firstName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
                <Col md={6}>
                  <Input
                    type="text"
                    name="lastName"
                    id="lastName"
                    innerRef={registerRegister({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="Last name"
                    className={errorsRegister?.lastName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your last name.{" "}
                    {errorsRegister?.lastName?.type === "required" && (
                      <i style={{ color: "red" }}> Last name is required.</i>
                    )}
                    {errorsRegister?.lastName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col md={6}>
                  <Input
                    type="text"
                    name="phoneNumber"
                    id="phoneNumber"
                    innerRef={registerRegister({
                      required: true,
                      pattern: {
                        value: /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                        message: "Enter a valid phone number",
                      },
                    })}
                    placeholder="Phone number ###-###-####"
                    className={errorsRegister?.phoneNumber ? "custError" : ""}
                    autoComplete="off "
                  />
                  <FormText>
                    Enter a phone number.
                    <i style={{ color: "red" }}>
                      {errorsRegister.phoneNumber &&
                        errorsRegister.phoneNumber.message}
                    </i>
                    {errorsRegister?.phoneNumber?.type === "required" && (
                      <i style={{ color: "red" }}> Phone number is required.</i>
                    )}
                  </FormText>
                </Col>
                <Col md={6}>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="E-mail"
                    innerRef={registerRegister({
                      required: true,
                      minLength: 3,
                      maxLength: 256,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email address.",
                      },
                    })}
                    className={errorsRegister?.email ? "custError" : ""}
                    autoComplete="off"
                  />
                  <FormText>
                    Enter your email.{" "}
                    <i style={{ color: "red" }}>
                      {errorsRegister.email && errorsRegister.email.message}
                    </i>
                    {errorsRegister?.email?.type === "required" && (
                      <i style={{ color: "red" }}> Email is required.</i>
                    )}
                    {errorsRegister?.lastName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col md={12}>
                  <Input
                    type="text"
                    name="barNumber"
                    id="barNumber"
                    innerRef={registerRegister({
                      required: true,
                      minLength: 3,
                      maxLength: 256,
                      pattern: {
                        value: /^[a-zA-Z0-9]*$/,
                        message: "Only alphanumeric characters",
                      },
                    })}
                    className={errorsRegister?.barNumber ? "custError" : ""}
                    placeholder="BAR number"
                  />
                  <FormText>
                    Enter your BAR number.{" "}
                    <i style={{ color: "red" }}>
                      {errorsRegister.barNumber &&
                        errorsRegister.barNumber.message}
                    </i>
                    {errorsRegister?.barNumber?.type === "required" && (
                      <i style={{ color: "red" }}> Bar number is required.</i>
                    )}
                    {errorsRegister?.barNumber?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col>
                  <Button
                    className="blueButton"
                    style={{ width: "100%", height: "100%" }}
                  >
                    Register
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Attorneys;
